import { render, staticRenderFns } from "./FormValidationAssistant.vue?vue&type=template&id=2f947538&"
import script from "./FormValidationAssistant.vue?vue&type=script&lang=js&"
export * from "./FormValidationAssistant.vue?vue&type=script&lang=js&"
import style0 from "./FormValidationAssistant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports